import { CalculationResult } from '../calculationModels';

export class JointCompletionForm {
    customer: string;
    projectnumber: string;
    jointid: string;
    vesselref: string;
    permanenttag: string;
    pidnumber: string;
    boltcoating: string;
    site: string;
    projectname: string;
    jointlocation: string;
    workpack: string;
    linenumber: string;
    isonumber: string;
    gasketfilter: string;
    gaugeserialnumber: string;
    toolserialnumber: string;
    referencedocument: string;
    instructedby: string;
    instructedcompany: string;
    instructedposition: string;
    assembledby: string;
    assembledcompany: string;
    assembleddate: string;
    tightenedbyone: string;
    tightenedby1company?: string;
    tightenedbyonedate: string;
    tightenedbytwo: string;
    tightenedby2company?: string;
    tightenedbytwodate: string;
    reportcompleted: string;
    reportcompleteddate: string;
    customeracceptance: string;
    customeracceptancecompany: string;
    customeracceptancedate: string;
    comments: string;
    jointcalculation: CalculationResult;
}
